import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../../service/http";

const AddAlert = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setForm({
      message: "",
    });
  };

  const handleSaveAsDraft = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await Api.post("web/alerts", {...form, status: "draft"});
      alert(response.data.message || "Alert created successfully!");
      navigate("/alerts");
    } catch (error) {
      console.error("Error creating alert:", error);
      alert("Failed to create alert. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveAsPublished = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await Api.post("web/alerts", {...form, status: "published"});
      alert(response.data.message || "Alert created successfully!");
      navigate("/alerts");
    } catch (error) {
      console.error("Error creating alert:", error);
      alert("Failed to create alert. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-0 h-full overflow-y-auto scrollbar-hide bg-gray-50/50">
      <div className="max-w-4xl mx-auto p-4 sm:p-6">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Add New Alert</h1>
          <p className="text-gray-500 text-sm mt-1">Create a new system alert to notify users.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-6 sm:p-8 space-y-6">
            <div>
              <label className="block mb-1.5 text-sm font-semibold text-gray-700">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all text-sm h-32 resize-none"
                placeholder="Enter alert message..."
                maxLength={255}
              />
              <p className="text-xs text-gray-400 mt-2 italic">
                A unique URL will be automatically generated for this alert.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row justify-end items-center gap-3 pt-6 border-t border-gray-100">
              <button
                type="button"
                onClick={() => navigate("/alerts")}
                className="w-full sm:w-auto px-6 py-2.5 bg-white border border-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-100 transition-all text-sm"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="w-full sm:w-auto px-6 py-2.5 bg-gray-100 text-gray-600 font-semibold rounded-xl hover:bg-gray-200 transition-all text-sm"
              >
                Reset
              </button>
              <button
                type="button"
                disabled={loading}
                className="w-full sm:w-auto px-6 py-2.5 bg-indigo-500 text-white font-semibold rounded-xl hover:bg-indigo-600 transition-all text-sm shadow-md shadow-indigo-100 disabled:opacity-50"
                onClick={handleSaveAsDraft}
              >
                {loading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="button"
                disabled={loading}
                className="w-full sm:w-auto px-8 py-2.5 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-all text-sm shadow-md shadow-indigo-100 disabled:opacity-50"
                onClick={handleSaveAsPublished}
              >
                {loading ? "Saving..." : "Publish Alert"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAlert;